import * as React from 'react';
import DSIconEdit from '@lmig/design-system-icons-react/_cjs/system/Edit';
import IconWrapper from '../IconWrapper';

/** @no-props */
var IconEdit = function IconEdit(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement(DSIconEdit, null));
};
export default IconEdit;